import styled from 'styled-components';
import { Typography } from 'modules/Typography';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
export const BREADCRUMB_MARGIN = theme.spacing.sm;
export const Container = styled.nav `
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${BREADCRUMB_MARGIN};

  /* prevent BreadcrumbItems from wrapping or growing larger than container */
  overflow: hidden;
  white-space: nowrap;
`;
export const ItemContainer = styled.div `
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 0 100 auto;
  transition: flex 0.1s ease-in-out;

  /* items may be too small to read, but they need to be wide enough to be able to click on them */
  min-width: ${pxToRem(10)};

  [data-icon='falcon'] {
    color: ${theme.swatches.gray[500]};
  }

  &:last-child {
    [data-icon='falcon'] {
      display: none;
    }
  }
`;
export const StyledTypography = styled(Typography).attrs((p) => (Object.assign(Object.assign({}, p), { $truncate: true }))) `
  color: ${theme.swatches.gray[500]};
  cursor: pointer;

  /* truncate the text of each item */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  font-size: ${theme.fontSize.small};
  margin-right: ${BREADCRUMB_MARGIN};
  transition: color 175ms ease-in-out;

  ${ItemContainer}:last-child & {
    /* no Link hover effect on the last item (which isn't clickable) */
    cursor: default;
    background-image: none;
    color: ${theme.semantic.foreground.primary};
    margin-right: 0;
    font-weight: ${theme.fontWeight.semibold};
  }

  &:hover {
    color: ${theme.semantic.foreground.primary};
  }
`;
export const StyledDiv = styled.div ``;
